import { createPlugin } from "@fullcalendar/core";
import { CoursesQuarterView, CoursesYearView } from "./CoursesYearView";

export default createPlugin({
  name: "coursesYearView",
  initialView: "yearView",
  optionRefiners: {},
  views: {
    yearView: {
      classNames: ["year-view"],
      component: CoursesYearView,
      duration: { years: 1 },
      dateIncrement: { years: 1 },
    },
    quarterView: {
      classNames: ["year-view", "quarter-view"],
      component: CoursesQuarterView,
      visibleRange: (currentDate: Date) => {
        const year = currentDate.getUTCFullYear();
        const month = currentDate.getUTCMonth() + 1;
        const quarterStartMonth = Math.floor((month - 1) / 3) * 3 + 1;
        const start = new Date(Date.UTC(year, quarterStartMonth - 1, 1));
        const end = new Date(Date.UTC(year, quarterStartMonth + 2, 1));
        return { start, end };
      },
      dateIncrement: { months: 3 },
      titleFormat: ({ start }) => {
        const quarter = Math.floor(start.month / 3) + 1;
        return `Q${quarter} ${start.year}`;
      },
    },
  },
});
